export default __webpack_public_path__ + "static/media/co1.d545e1bb.png";